var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data.headings.length > 0)?_c('div',{staticClass:"b-content-headline"},[_vm._l((_vm.data.headings),function(heading,i){return [(i > 0)?_c('spacer'):_vm._e(),_c('heading',{attrs:{"title":heading.headline,"tagTitle":heading.headlineTag,"classTitle":heading.headlineClass,"suptitle":heading.suptitle}})]})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }